<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/bank-account">Contas bancárias</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Atualizar integração</li>
                <li class="breadcrumb-item active" aria-current="page">{{ bank_account.name }}</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-body">
                        <form @submit="update">
                            <div class="row mt-3">
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Banco*</label>
                                    <multiselect v-model="gateway_bank_selected" :options="gateways_available_options"
                                        placeholder="Selecione uma opção" :select-label="'Clique para selecionar'"
                                        :deselect-label="'Clique para remover'" @select="handleSelectBank"
                                        :custom-label="bankWithLang">
                                        <template #noResult>
                                            Nenhum banco encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">URL Gateway*</label>
                                    <input type="text" class="form-control" placeholder="Ex: https://api.gateway.com.br"
                                        v-model="gateway.url">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Token</label>
                                    <input type="text" class="form-control" placeholder="Ex: Bearer xyz"
                                        v-model="gateway.token">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">ClientID</label>
                                    <input type="text" class="form-control" placeholder="Ex: 123456"
                                        v-model="gateway.client_id">
                                </div>
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Client Secret</label>
                                    <input type="text" class="form-control" placeholder="Ex: *******"
                                        v-model="gateway.client_secret">
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Certificado <small>(Tamanho máximo: 2MB)</small></label>
                                    <input type="file" @change="handleFileChange">
                                </div>
                            </div>
                            <div class="row mt-3" v-if="file.size != ''">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <small class="mt-5">Tamanho arquivo selecionado: {{ file.size }}</small>
                                </div>
                            </div>
                            <div class="row mt-5" v-if="progressBarFile > 0">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <div class="progress">
                                        <div class="progress-bar bg-success" role="progressbar"
                                            :style="'width:' + progressBarFile + '%'" aria-valuenow="25"
                                            aria-valuemin="0" aria-valuemax="100">Progresso</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                            class="fa fa-save"></i> Atualizar</button>
                                    <button v-if="gateway.id" type="submit" :disabled='!isDisabled'
                                        class="btn btn-warning ml-3" @click="testConnection"><i class="fa fa-link"></i>
                                        Testar conexão</button>
                                    <router-link to="/bank-account" class="btn btn-danger ml-3"><i
                                            class="fa fa-times"></i>
                                        Cancelar</router-link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import Multiselect from 'vue-multiselect'

export default {

    components: { Loading, Multiselect },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            bank_account: { id: '', name: '' },
            gateways_available_options: [],
            gateway_bank_selected: '',
            progressBarFile: 0,

            gateway: {
                id: '',
                url: '',
                token: '',
                client_id: '',
                client_secret: '',
                code: ''
            },
            file: { size: 0 },
            enable_error_list: false,
            errors: []
        }
    },

    computed: {
        isDisabled: function () {
            return this.gateway.url != '' && this.gateway.code != '';
        }
    },
    mounted() {
        this.isLoading = false;
        const id = this.$route.params.id;
        this.gateway.id = id;
        this.loadBankAccountAvailableIntegration();
        this.getBankAccountGateway();

    },
    methods: {
        onCancel() { },
        loadBankAccountAvailableIntegration() {
            this.isLoading = true;
            api.get('/gateway-available')
                .then((response) => {
                    this.isLoading = false;

                    this.gateways_available_options = response.data.availables.map(item => ({
                        key: item.code,
                        value: item.code
                    }));
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },
        handleFileChange(event) {
            if (event.target.files[0] != undefined) {
                const sizeInBytes = event.target.files[0].size;
                const sizeInMB = sizeInBytes / (1024 * 1024);
                if (sizeInMB > 2) {
                    this.$notify({
                        title: "Informação",
                        text: "Seu arquivo excede o limite de envio. O máximo para envio são 2MB",
                        type: 'info'
                    });
                    this.file.archive = null;
                } else {
                    this.file.archive = event.target.files[0];
                }
                this.file.size = sizeInMB.toFixed(2) + 'MB';

            } else {
                this.file.size = '';
                this.file.archive = null;
            }

        },
        handleSelectBank(option) {
            this.gateway.code = option.key;
        },
        bankWithLang({ value }) {
            return value;
        },
        getBankAccountGateway() {
            api.get('/bank-account/' + this.gateway.id + '/gateway')
                .then((response) => {
                    this.isLoading = false;
                    this.bank_account = response.data.bank_account;
                    if (response.data.gateway != '') {
                        this.gateway = response.data.gateway;
                        this.gateway_bank_selected = { 'key': this.gateway.code, 'value': this.gateway.code };
                        this.gateway.id = response.data.bank_account.id;
                    }

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },

        testConnection(event) {
            event.preventDefault();
            this.isLoading = true;
            api.post('/test-connection-gateway/' + this.bank_account.id)
                .then((response) => {
                    this.isLoading = false;
                    let status = response.data.response.status;
                    if (status == 200) {
                        this.$notify({
                            title: "Sucesso",
                            text: "Conexão realizada com sucesso! O status da conta é: " + response.data.response.status_account,
                            type: 'success'
                        });
                    } else if (status == 401) {
                        this.$notify({
                            title: "Falha",
                            text: "Conexão não autorizada. Verifique os dados informados na configuração e tente novamente!",
                            type: 'error'
                        });
                    } else {
                        this.$notify({
                            title: "Falha",
                            text: "Falha ao realizar conexão. Por gentileza, contacte o suporte técnico para mais detalhes",
                            type: 'error'
                        });
                    }
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })
        },

        update(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            const formData = new FormData();
            formData.append('url', this.gateway.url);
            formData.append('token', this.gateway.token);
            formData.append('client_id', this.gateway.client_id);
            formData.append('client_secret', this.gateway.client_secret);
            formData.append('code', this.gateway.code);
            api.post('/bank-account/' + this.gateway.id + '/gateway', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Configurações do gateway atualizada com sucesso!",
                        type: 'success'
                    });
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })

        }
    }
}
</script>

<style lang="scss" scoped></style>